// extracted by mini-css-extract-plugin
export default {"productCarousel":"z3-z"};